import { render, staticRenderFns } from "./MergeContact.vue?vue&type=template&id=7b370669&scoped=true&"
import script from "./MergeContact.vue?vue&type=script&lang=js&"
export * from "./MergeContact.vue?vue&type=script&lang=js&"
import style0 from "./MergeContact.vue?vue&type=style&index=0&id=7b370669&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b370669",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b370669')) {
      api.createRecord('7b370669', component.options)
    } else {
      api.reload('7b370669', component.options)
    }
    module.hot.accept("./MergeContact.vue?vue&type=template&id=7b370669&scoped=true&", function () {
      api.rerender('7b370669', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/contact/components/MergeContact.vue"
export default component.exports